import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Skeleton } from "@/components/Home/components/Skeleton";
/** 시스템 카테고리 페이지 스켈레톤 */ const CategoryPageSkeleton = ()=>{
    return /*#__PURE__*/ _jsx("div", {
        className: "min-h-screen bg-white",
        children: /*#__PURE__*/ _jsx("div", {
            className: "mx-auto max-w-[1200px] px-4 md:px-6",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "flex gap-12",
                children: [
                    /*#__PURE__*/ _jsx("aside", {
                        className: "hidden w-50 shrink-0 md:block lg:w-60",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "sticky top-[72px]",
                            children: /*#__PURE__*/ _jsxs("nav", {
                                className: "flex w-60 flex-col gap-4 bg-white py-6",
                                children: [
                                    /*#__PURE__*/ _jsx(Skeleton, {
                                        className: "h-7 w-32 bg-gray-200"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex flex-col",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "min-h-10 rounded-sm bg-gray-50 px-2 py-2",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "flex items-center justify-between",
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Skeleton, {
                                                            className: "h-5 w-24 bg-gray-200"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Skeleton, {
                                                            className: "size-3 bg-gray-200"
                                                        })
                                                    ]
                                                })
                                            }),
                                            Array.from({
                                                length: 3
                                            }).map((_, index)=>/*#__PURE__*/ _jsx("div", {
                                                    className: "ml-3 min-h-10 px-2 py-2",
                                                    children: /*#__PURE__*/ _jsx("div", {
                                                        className: "h-4 animate-pulse rounded-md bg-gray-100",
                                                        style: {
                                                            width: "".concat(60 + index * 10, "%")
                                                        }
                                                    })
                                                }, "2d-".concat(index))),
                                            Array.from({
                                                length: 4
                                            }).map((_, index)=>/*#__PURE__*/ _jsx("div", {
                                                    className: "min-h-10 px-2 py-2",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex items-center justify-between",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "h-5 animate-pulse rounded-md bg-gray-100",
                                                                style: {
                                                                    width: "".concat(50 + index * 8, "%")
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx(Skeleton, {
                                                                className: "size-3 bg-gray-100"
                                                            })
                                                        ]
                                                    })
                                                }, "1d-".concat(index)))
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("main", {
                        className: "min-w-0 flex-1 pt-6",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "flex flex-col gap-6 sm:gap-8",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex flex-col gap-3 md:gap-4",
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex items-center gap-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Skeleton, {
                                                    className: "h-4 w-16 bg-gray-200"
                                                }),
                                                /*#__PURE__*/ _jsx(Skeleton, {
                                                    className: "h-4 w-4 bg-gray-100"
                                                }),
                                                /*#__PURE__*/ _jsx(Skeleton, {
                                                    className: "h-4 w-20 bg-gray-200"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Skeleton, {
                                            className: "h-8 w-48 bg-gray-200"
                                        }),
                                        /*#__PURE__*/ _jsx(Skeleton, {
                                            className: "aspect-[4/1] w-full bg-gray-200 md:aspect-[912/140]"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-between py-2",
                                    children: [
                                        /*#__PURE__*/ _jsx(Skeleton, {
                                            className: "h-5 w-20 bg-gray-200"
                                        }),
                                        /*#__PURE__*/ _jsx(Skeleton, {
                                            className: "h-8 w-24 bg-gray-100"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex flex-col",
                                    children: Array.from({
                                        length: 5
                                    }).map((_, index)=>/*#__PURE__*/ _jsx("div", {
                                            className: "p-5 ".concat(index < 4 ? "border-b border-gray-100" : ""),
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "flex items-start gap-4",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Skeleton, {
                                                        className: "size-[72px] shrink-0 bg-gray-200"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "min-w-0 flex-1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Skeleton, {
                                                                className: "h-5 w-3/4 bg-gray-200"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Skeleton, {
                                                                className: "mt-1 h-4 w-24 bg-gray-100"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Skeleton, {
                                                                className: "mt-1.5 h-5 w-32 bg-gray-200"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, index))
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
export default CategoryPageSkeleton;
